import { render } from "./body-wrapper.vue?vue&type=template&id=61869c34&ts=true"
import script from "./body-wrapper.vue?vue&type=script&lang=ts"
export * from "./body-wrapper.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__